import { render } from "./ChildConfirm.vue?vue&type=template&id=6e9df86d&scoped=true"
import script from "./ChildConfirm.vue?vue&type=script&lang=js"
export * from "./ChildConfirm.vue?vue&type=script&lang=js"

import "./ChildConfirm.vue?vue&type=style&index=0&id=6e9df86d&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e9df86d"]])

export default __exports__